<template>
    <rkm-overlay>
        <rkm-layout-body title="C7 - Cuidado da mulher na prevenção do câncer">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/atencao-basica/relatorio-cuidado-mulher-prevencao-cancer/List'

export default {
    components: { List },
}
</script>